import React, { Component } from 'react';

import ParkinglocationSelect from './ParkinglocationSelect';
import PlaceRolesSelect from './PlaceRolesSelect';

import { Form, Input, Button, Modal, InputNumber } from 'antd';
const FormItem = Form.Item;

class ParkinglocationPlacesForm extends Component {

  state = {
    modalVisible: false
  }

  form = null;

  componentWillReceiveProps(nextProps) {
    this.setState({
      modalVisible: nextProps.modalVisible
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let position = {
          "type": "Point",
          "coordinates": [
            values.positionLon !== undefined ? values.positionLon : 0.0,
            values.positionLat !== undefined ? values.positionLat : 0.0
          ]
        };
        values.coords = position;
        delete values.positionLat;
        delete values.positionLon;
        this.props.onSuccess(this.props.form, values);
        this.props.onModalCancel();
        this.setState({ modalVisible: false });
      }
    });
  }

  renderForm() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
        {!this.props.initialValues &&
          <FormItem
            {...formItemLayout}
            label="Lokalita" >
            {getFieldDecorator('parkingLocationId', {
              initialValue: this.props.parkingLocationId
                ? this.props.parkingLocationId
                : null,
              rules: [{
                required: true, message: 'Vyplňte prosím tuto položku!',
              }],
            })(
              <ParkinglocationSelect onChange={(value) => { this.props.form.setFieldsValue({ parkingLocationId: value }); }} />
            )}
          </FormItem>
        }
        <FormItem
          {...formItemLayout}
          label="Výchozí role" >
          {getFieldDecorator('actualRoleID', {
            initialValue: this.props.initialValues && this.props.initialValues.actualRoleID
              ? this.props.initialValues.actualRoleID
              : [],
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <PlaceRolesSelect onChange={(value) => { this.props.form.setFieldsValue({ actualRoleID: value }); }} />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Role" >
          {getFieldDecorator('roles', {
            initialValue: this.props.initialValues && this.props.initialValues.roles
              ? this.props.initialValues.roles
              : [],
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <PlaceRolesSelect mode="multiple" onChange={(value) => { this.props.form.setFieldsValue({ roles: value }); }} />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Místo" >
          {getFieldDecorator('placeID', {
            initialValue: this.props.initialValues && this.props.initialValues.placeID
              ? this.props.initialValues.placeID
              : null,
            rules: [{
              type: 'number', message: 'Položka musí obsahovat číslo!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <InputNumber min={1} max={999999} />
          )}
        </FormItem>
        <Form.Item
          {...formItemLayout}
          label="Zeměpisná šířka">
          {getFieldDecorator('positionLat', {
            initialValue: this.props.initialValues && this.props.initialValues.coords
              ? this.props.initialValues.coords.coordinates[1]
              : null,
            rules: [{
              type: 'number', message: 'Položka musí obsahovat číslo!',
            }],
          })(
            <InputNumber />
          )}
        </Form.Item>
        <Form.Item
          {...formItemLayout}
          label="Zeměpisná výška">
          {getFieldDecorator('positionLon', {
            initialValue: this.props.initialValues && this.props.initialValues.coords
              ? this.props.initialValues.coords.coordinates[0]
              : null,
            rules: [{
              type: 'number', message: 'Položka musí obsahovat číslo!',
            }],
          })(
            <InputNumber />
          )}
        </Form.Item>
        <FormItem {...tailFormItemLayout}>
          {this.props.initialValues
            ?
            <Button type="primary" htmlType="submit">Uložit</Button>
            :
            <Button type="primary" htmlType="submit">Vložit</Button>
          }
        </FormItem>
      </Form>
    );
  }

  render() {
    if (this.props.type && this.props.type === 'modal') {
      return (
        <Modal
          width={650}
          title={this.props.initialValues ? "Nastavení parkovacího místa" : "Vytvoření parkovacího místa"}
          visible={this.state.modalVisible}
          onCancel={() => {
            this.props.onModalCancel(this.props.form);
            this.setState({ modalVisible: false });
          }}
          footer={<p></p>}>
          {this.renderForm()}
        </Modal>
      )
    } else {
      return this.renderForm();
    }
  }
}

const WrappedParkinglocationForm = Form.create()(ParkinglocationPlacesForm);

export default WrappedParkinglocationForm;


// WEBPACK FOOTER //
// ./src/components/ParkinglocationPlacesForm.js